module.exports = __webpack_public_path__ + "static/media/icon_factory.8def9f9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_factory.png
// module id = 3567
// module chunks = 0